import type { NeedsActionGroup, NeedsActionRow, NeedsActionSummary } from './types';

export const NEEDS_ACTION_GROUPS: readonly NeedsActionGroup[] = ['owed', 'payment_problem', 'refunded_twice', 'waiting'];
export const NEEDS_ACTION_BADGE_GROUPS: readonly NeedsActionGroup[] = ['owed', 'payment_problem', 'refunded_twice'];
export const NEEDS_ACTION_RESOURCE = 'kiosk-transactions-needs-action';

type Translate = (key: string, options?: any) => string;

const MINUTE = 60000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export function needsActionBadgeCount(summary: NeedsActionSummary): number {
  return NEEDS_ACTION_BADGE_GROUPS.reduce((sum, group) => sum + summary[group], 0);
}

export function formatDuration(ms: number, translate: Translate): string {
  const span = Math.max(0, ms);
  if (span < HOUR) return translate('resources.kiosk-transactions.needsAction.duration.minutes', { n: Math.floor(span / MINUTE) });
  if (span < 2 * DAY) return translate('resources.kiosk-transactions.needsAction.duration.hours', { n: Math.floor(span / HOUR) });
  return translate('resources.kiosk-transactions.needsAction.duration.days', { d: Math.floor(span / DAY), h: Math.floor((span % DAY) / HOUR) });
}

export function needsActionTiming(row: Pick<NeedsActionRow, 'id' | 'group' | 'since' | 'expiresAt'>, now: number, translate: Translate): string {
  const waited = formatDuration(now - Date.parse(row.since), translate);
  switch (row.group) {
    case 'owed':
      return translate('resources.kiosk-transactions.needsAction.owedFor', { duration: waited });
    case 'payment_problem':
      return translate('resources.kiosk-transactions.needsAction.problemFor', { duration: waited });
    case 'refunded_twice':
      return translate('resources.kiosk-transactions.needsAction.twiceAgo', { duration: waited });
    case 'waiting': {
      if (row.expiresAt === null) throw new Error(`waiting kiosk payment ${row.id} has no expiry`);
      const left = Date.parse(row.expiresAt) - now;
      return left > 0
        ? translate('resources.kiosk-transactions.needsAction.timeLeft', { duration: formatDuration(left, translate) })
        : translate('resources.kiosk-transactions.needsAction.movesSoon');
    }
  }
}
